<template>
  <div v-if="teacherList.length">
    <div
      v-for="(item, index) in teacherList"
      :key="index"
      class="teacher-item clear"
    >
      <div
        class="teacher-item__avatar"
        :style="{
          backgroundImage: `url(${item.avatar})`
        }"
      />
      <div class="teacher-item__info">
        <p class="teacher-item__info__job-title">
          {{ item.typeName }}
        </p>
        <p class="teacher-item__info__name">
          {{
            item.name
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teacherModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      teacherList: []
    }
  },
  watch: {
    teacherModule(val) {
      console.log('watch', val)
      if (val) {
        this.getTeacherList()
      }
    }
  },
  mounted() {
    this.getTeacherList()
  },
  methods: {
    getTeacherList() {
      this.teacherList = []
      if (this.teacherModule.chinaTeacher) {
        this.teacherModule.chinaTeacher.forEach((item) => {
          console.log(item)
          this.teacherList.push(item)
        })
      }

      if (this.teacherModule.foreignTeacher) {
        this.teacherModule.foreignTeacher.forEach((item) => {
          this.teacherList.push(item)
        })
      }
      if (this.teacherModule.counsolerInfo) {
        this.teacherModule.counsolerInfo.forEach((item) => {
          this.teacherList.push(item)
        })
      }

      console.log(this.teacherList)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
  @include b(teacher-item) {
  position: relative;
  display: inline-block;
  margin-top: 20px;
  vertical-align: middle;
  margin-right: 21px;
  @include e(avatar) {
    width: 32px;
    height: 32px;
    float: left;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 100%;
    overflow: hidden;
    border: 1px solid #f1f1f1;
    display: inline;
  }
  @include e(info) {
    float: left;
    width: 52px;
    margin-left: 4px;
    p {
      height: 16px;
      line-height: 16px;
      font-size: 13px;
      color: #666;
      overflow: hidden;
    }
    @include e(job-title) {
      color: #999;
    }
  }
  @include e(label) {
    display: inline-block;
    max-width: 120%;
    text-align: center;
    background-image: url('//res12.xesimg.com/x5mall/img/student_num_label.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 74px;
    height: 23px;
    font-size: 12px;
    line-height: 23px;
    color: #fe6d24;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/teacher.vue